/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import type { BuilderPlanActionView } from './aiBuilderPlanStatus';

interface BuilderSuggestedReplyCardProps {
  actionView: BuilderPlanActionView;
  onUseSuggestedReply: (message: string) => void;
  compact?: boolean;
}

const BuilderSuggestedReplyCard: React.FC<BuilderSuggestedReplyCardProps> = ({
  actionView,
  onUseSuggestedReply,
  compact = false,
}) => {
  return (
    <Box
      sx={{
        mt: compact ? 1 : 1.25,
        px: 1.25,
        py: compact ? 1 : 1.1,
        borderRadius: 1.25,
        border: 1,
        borderColor: 'divider',
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
        {actionView.title}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.35 }}>
        {actionView.summary}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.1 }}>
        <Button
          size="small"
          variant="contained"
          color={
            actionView.tone === 'warning'
              ? 'warning'
              : actionView.tone === 'success'
                ? 'success'
                : 'primary'
          }
          onClick={() => onUseSuggestedReply(actionView.primaryMessage)}
        >
          {actionView.primaryLabel}
        </Button>
        {actionView.secondaryLabel && actionView.secondaryMessage ? (
          <Button
            size="small"
            variant="outlined"
            onClick={() => onUseSuggestedReply(actionView.secondaryMessage as string)}
          >
            {actionView.secondaryLabel}
          </Button>
        ) : null}
      </Box>
      {actionView.note ? (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 0.85 }}
        >
          {actionView.note}
        </Typography>
      ) : null}
    </Box>
  );
};

export default BuilderSuggestedReplyCard;
